<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="page_25"></a><a id="pg25lev1"></a><img alt="Morcilla, egg, and crisps" src="images/f0025-01.jpg"/></h2>
<p class="recipe_hdnote">Okay, so it sounds a little out there, but this tasty tapa is not as crazy as you might think. Unlike the British relationship with crisps (potato chips), which might involve a stop by the corner shop for a sneaky bag of Walker’s, there’s a long-standing tradition of handmade, freshly fried crisps in Spain. I ate this dish in a tapas bar in Barcelona; I loved the idea that you can pimp up a bag of potato chips, so I have re-created it here.</p>
<div class="wrap">
<p class="image"><a id="page_24"></a><img alt="image" class="vertical" src="images/f0024-01.jpg"/></p>
</div>
<p class="yield">Serves 4</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common.jpg"/></p>
</div>
<p class="yield">Preparation time: 2 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common1.jpg"/></p>
</div>
<p class="yield">Cooking time: 10 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common2.jpg"/></p>
</div>
<p class="ingred_sublist">one 2-oz bag salted potato chips</p>
<p class="ingred_sublist">5 oz morcilla (blood sausage), casing removed</p>
<p class="ingred_sublist">1 tbsp olive or canola oil</p>
<p class="ingred_sublist">3 eggs</p>
<p class="method_txt">Empty the bag of chips into a serving dish.</p>
<p class="method_txt">Roughly crumble or chop the morcilla. Heat a large nonstick frying pan over high heat and dry-fry the morcilla for 3 to 4 minutes, until cooked through. Scatter the sausage over the chips.</p>
<p class="method_txt">Add the oil to the frying pan, heat, and crack the eggs in one by one. Cook for 2 to 3 minutes, until the whites are set but the yolks are still runny (put a lid or plate over the pan to speed it up).</p>
<p class="method_txt">Using a spatula, gently place the fried eggs over the morcilla and serve.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12-chapter06.vue?613457f0